import { MtModule } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setModuleList = (moduleList: types.ModuleList) => ({
    type: inferLiteral(types.MODULE_LIST),
    moduleList,
})
export const setModuleIds = (moduleIds: readonly number[]) => ({
    type: inferLiteral(types.MODULE_IDS),
    moduleIds,
})
export const setModuleView = (module: MtModule) => ({
    type: inferLiteral(types.MODULE_VIEW),
    module,
})
export const setModuleEdit = (module: MtModule) => ({
    type: inferLiteral(types.MODULE_EDIT),
    module,
})
export const setModuleSort = (sortColumn: keyof MtModule, sortOrder: OrderType) => ({
    type: inferLiteral(types.MODULE_SORT),
    sortColumn,
    sortOrder,
})
export const setModuleFilters = (filters: types.ModuleFilters) => ({
    type: inferLiteral(types.MODULE_FILTERS),
    filters,
})
export const setModuleReloadList = (value: boolean) => ({
    type: inferLiteral(types.MODULE_RELOAD_LIST),
    value,
})
export const setModuleReloadView = (value: boolean) => ({
    type: inferLiteral(types.MODULE_RELOAD_VIEW),
    value,
})
export const setModuleReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MODULE_RELOAD_EDIT),
    value,
})
